import { render, staticRenderFns } from "./SkinInquiry.vue?vue&type=template&id=35f3fc9c&scoped=true"
import script from "./SkinInquiry.vue?vue&type=script&lang=js"
export * from "./SkinInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3fc9c",
  null
  
)

export default component.exports